// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import {
  OAuthScope,
  oauthScopeSchema,
} from '@/account/api/get-connected-applications';

/** Says in plain words what a credential holding the scopes may do. */
export function toPermissionLabel(scopes: OAuthScope[]) {
  return scopes.includes(oauthScopeSchema.enum['hardfin:write'])
    ? 'Can read and change'
    : 'Can read';
}
